import { InputFieldState } from '@servicetitan/form-state';
import { runInAction } from 'mobx';
import { KeyboardEvent } from 'react';

export const handleEmailSpaceKeyDown =
    (field: InputFieldState<any>) => (e: KeyboardEvent<HTMLInputElement>) => {
        if (e.code === 'Space') {
            e.preventDefault();
            if (typeof field.value === 'string') {
                runInAction(() => {
                    field.value = field.value.trim();
                });
            }
        }
    };
